import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Cell, LabelList, ResponsiveContainer } from "recharts";

// const data = [
//   { name: "Street A", delay: 5 },
//   { name: "Street B", delay: 10 },
//   { name: "Street C", delay: 15 },
//   { name: "Street D", delay: 17 },
//   { name: "Street E", delay: 7 }
// ];

const tickFormatter = (value) => {
  if (value === 0) {
    return "Delay";
  }
  return `+${value} min`;
};

const HorizontalBar = (props) => {
  const [data, setData] = useState(null);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    if(props?.data){
      props?.data.map(x => {
        const value = x?.value;

        if(value >= 15){
          colors.push('red')
        } else if(value >= 10 ){
          colors.push('orange')
        } else if(value >= 5){
          colors.push('yellow')
        } else if(value < 5){
          colors.push('green')
        }
      })

      setData(props.data);
    }
  }, [])

  return (
    <ResponsiveContainer>
      <BarChart data={data} layout="vertical"
        margin={{
          top: 50,
          right: 60,
          left: 60,
          bottom: 10,
        }}>
        <CartesianGrid strokeDasharray="3 3" stroke="none" strokeWidth={0} />
        <YAxis type="category" dataKey="name" padding={{ bottom: 10 }} hide/>
        <Bar dataKey="value" barSize={20}>
          <LabelList
            dataKey="name"
            position="insideBottomLeft"
            angle={0}
            offset={35}
            fill="black"
            fontSize='3rem'
            // fontWeight="bold"
            width={400}
          />
          {colors.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % 20]} radius={20}/>
            ))}
        </Bar>
        <XAxis type="number" tick={{ fontSize: 30 }} tickLine={false} tickFormatter={tickFormatter}/>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HorizontalBar;
